import React from "react";

// Define the skeleton element
const SkeletonElement = ({ type, style }) => {
  return (
    <div
      className={`skeleton ${type}`}
      style={style != null ? style : {}}
    ></div>
  );
};

export default SkeletonElement;
